const REACT_APP_API_ENDPOINT = `${process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT}/api/v1`;
const CONTAINER_API_ENDPOINT = REACT_APP_API_ENDPOINT + "/container";


export default {
    GET_LIST_CONTAINER:                                         CONTAINER_API_ENDPOINT + "/get/list",
    GET_LIST_CONTAINER_WITH_PAGINATION:                         CONTAINER_API_ENDPOINT + "/list",
    CREATE_CONTAINER:                                           CONTAINER_API_ENDPOINT + "/create",
    VIEW_CONTAINER:                                             CONTAINER_API_ENDPOINT + "/view",
    UPDATE_CONTAINER_STATUS:                                    CONTAINER_API_ENDPOINT + "/update/status",
    UPDATE_CONTAINER:                                           CONTAINER_API_ENDPOINT + "/update",
    FILTER_CONTAINER:                                           CONTAINER_API_ENDPOINT + "/filter/list",

    // common
    GET_CONTAINER_TYPES:                                        CONTAINER_API_ENDPOINT + "/type/list",
    GET_CONTAINER_STATUS_LIST:                                  CONTAINER_API_ENDPOINT + "/status/list",
}